/** 二次确认保留未知请求完整指纹，重试不得换目标版或动作键。 */
function createFinalConfirmation({
    request,
    API,
    serviceOrderNo,
    key = () => `confirm-${Date.now()}-${Math.random().toString(36).slice(2)}`,
}) {
    const state = { busy: false, unknown: false, error: '', result: null };
    let pending = null;
    return {
        state,
        async submit(summary, confirmed) {
            if (state.busy || state.result) return false;
            if (!confirmed) {
                state.error = '请再次确认接受当前完整精修结果';
                return false;
            }
            if (!pending) {
                if (
                    summary.paused ||
                    ![4, 6].includes(summary.stage) ||
                    ![1, 2].includes(summary.currentVersionNo)
                ) {
                    state.error = '当前阶段无法确认，请重新加载订单';
                    return false;
                }
                pending = {
                    idempotencyKey: key(),
                    targetVersionNo: summary.currentVersionNo,
                    confirmed: 1,
                };
            }
            state.busy = true;
            state.error = '';
            try {
                const response = await request.post(
                    API.photography.confirm(serviceOrderNo),
                    pending
                );
                const p = response.data || {};
                if (p.code !== 200 || p.success === false) {
                    const error = Error(p.message || '确认未生效，请重新加载订单');
                    error.response = response;
                    throw error;
                }
                const data = p.data !== undefined ? p.data : p.result;
                if (!data || data.stage !== 8 || !data.finalCompletedAt) {
                    state.unknown = true;
                    throw Error('确认结果待核实，请用原请求重试');
                }
                state.result = data;
                state.unknown = false;
                return true;
            } catch (e) {
                const status =
                    e.response && Math.max(Number(e.response.status)||0,Number(e.response.data && e.response.data.code)||0);
                if (pending && (!e.response || status >= 500)) state.unknown = true;
                else {
                    state.unknown = false;
                    pending = null;
                }
                state.error = state.unknown ? '确认结果待核实，请用原请求重试' : e.message;
                return false;
            } finally {
                state.busy = false;
            }
        },
    };
}
module.exports = { createFinalConfirmation };
